import type { App } from "vue";
import mqInit from "@/engine/vendors/mq";
import toolkitInit from "@/engine/vendors/toolkit";

export default function initVendors(app: App) {
  mqInit(app);
  toolkitInit(app);
}
